// This utility function can be used if it is not possible to use CSS Grid like in the DS Carousel component.
// Required: All columns should have the same amount of 'rows'. So if a title is not there, it should still have an empty div.
// Optional: Call this function also in a (debounced) resize event listener to update on resize.
export const syncRowHeights = (parentContainer, isResizing = false) => {
    var _a;
    if (!parentContainer)
        return;
    const columns = Array.from(parentContainer.children);
    const rowCount = ((_a = columns[0]) === null || _a === void 0 ? void 0 : _a.children.length) || 0;
    const maxHeights = Array(rowCount).fill(0);
    if (!columns)
        return;
    // Calculate maximum heights for each row index across columns
    columns.forEach(column => {
        Array.from(column.children).forEach((row, rowIndex) => {
            if (isResizing) {
                row.style.removeProperty('height');
            }
            const rowHeight = row.getBoundingClientRect().height;
            maxHeights[rowIndex] = Math.max(maxHeights[rowIndex], rowHeight);
        });
    });
    // Apply the maximum height to all rows at the same index
    columns.forEach(column => {
        Array.from(column.children).forEach((row, rowIndex) => {
            row.style.height = `${maxHeights[rowIndex]}px`;
        });
    });
};
//# sourceMappingURL=syncRowHeights.js.map